<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import RangeSlider from 'svelte-range-slider-pips';

  import { theme, ThemeModes } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  const dispatch = createEventDispatcher();

  export let min: number;
  export let max: number;
  export let formatter: ((value: number) => string) | undefined = undefined;
  export let values: number[] = [];
  export let rest: string | boolean | undefined = undefined;

  const handleStart = (event: CustomEvent) => {
    dispatch('start', event.detail);
  };

  const handleStop = (event: CustomEvent) => {
    dispatch('stop', event.detail);
  };
</script>

<div class="{cn('range-slider', { dark: $theme === ThemeModes.Dark })}">
  <RangeSlider
    step="{1}"
    {min}
    {max}
    {formatter}
    bind:values
    first="label"
    last="label"
    hoverable="{false}"
    range
    pips
    float
    on:start="{handleStart}"
    on:stop="{handleStop}"
    {rest}
  />
</div>

<style lang="scss">
  :global(.rangeSlider) {
    --range-range-inactive: #e9e9e9;
    --range-range: #737373; /* active range color */
    --range-handle-inactive: #cccccc; /* inactive handle color */
    --range-handle: #171717; /* non-focussed handle color */
    --range-handle-focus: #171717; /* focussed handle color */
  }

  .range-slider :global(.pipVal) {
    color: #171717;
    font-weight: 500;
  }

  .range-slider :global(.rangeHandle) {
    width: 26px;
    height: 26px;
  }

  .range-slider :global(.rangeSlider.range:not(.min):not(.max) .rangeNub) {
    border-radius: 100%;
  }

  .range-slider :global(.rangeSlider.range:not(.min):not(.max) .rangeHandle.active .rangeNub) {
    border-radius: 10em 10em 10em 1.6em;
  }

  .range-slider :global(.pip.selected .pipVal) {
    font-weight: 500;
  }

  .range-slider :global(.pip .pipVal) {
    transform: none;
  }

  .range-slider :global(.pip.first .pipVal) {
    transform: translateX(0%);
  }

  .range-slider :global(.pip.last .pipVal) {
    transform: translateX(-100%);
  }

  .dark :global(.pipVal) {
    color: #ffffff;
  }

  .dark :global(.rangeSlider) {
    --range-range-inactive: #4d4d4d;
    --range-range: #acacac; /* active range color */
    --range-handle-inactive: #666; /* inactive handle color */
    --range-handle: #fff; /* non-focussed handle color */
    --range-handle-focus: #fff; /* focussed handle color */
    --range-float-text: #171717;
    --range-pip-in-range: #666666;
  }
</style>
